<template>
  <div>
    <div style="background: white">
      <K2Row justify_content="center" class="position-relative p-4">
        <K2Row
          :style="{ background: uiVariable.color.button1 }"
          style="cursor: pointer"
          class="backButton pe-3 rounded po"
          align="center"
          @onclick="handleBack"
        >
          <K2Icon color="white" name="chevron_left" font-size="29px" />
          <K2Text color="white">{{ lang('Back') }}</K2Text>
        </K2Row>
        <K2Heading type="h5" class-name="mb-0" color="black" v-if="staffData">{{ staffData.StaffName }}</K2Heading>
      </K2Row>
      <div class="py-2 border-top" :style="{ borderColor: uiVariable.color.backgroundGrey2 }" v-if="staffData">
        <K2Text>{{ staffData.Moments }} Moments | {{ staffData.Students }} Students</K2Text>
      </div>
    </div>

    <div style="background: white" class="m-4">
      <K2StudentList
        :staffID="staffData.StaffID"
        :studentList="studentList"
        :studentAction="studentAction"
        :studList="studList"
        :dateRange="dateRange"
        v-if="staffData"
      />
    </div>
  </div>
</template>
<script>
import K2Heading from '../../uiComponents/k2Heading/k2Heading'
import { lang } from '../../locale'
import uiVariable from '../../config/uiVariable'
import K2Row from '../../uiComponents/k2Row/k2Row'
import K2Icon from '../../uiComponents/k2Icon/k2MAIcon'
import K2Text from '../../uiComponents/k2Text/k2Text'
import DataSource from '../../data/datasource'
import K2StudentList from '../../uiComponents/k2Student/k2StudentList'

export default {
  name: 'DashboardStatePage',
  components: { K2StudentList, K2Heading, K2Text, K2Icon, K2Row },
  props: ['handleBack', 'post'],
  data() {
    return {
      uiVariable: uiVariable,
      studentList: [
        {
          prop: 'Index_No',
          label: 'Student ID',
        },
        {
          prop: 'Full_Name',
          label: 'Student Name',
        },
        {
          prop: 'St_AccYear',
          label: 'Academic Year',
        },
        {
          prop: 'levelAndClassName',
          label: 'Class (Level)',
        },
      ],
      studentAction: [
        {
          props: {
            type: 'primary',
            icon: 'el-icon-edit',
          },
          handler: row => {
            if (this.$route.query.mode === 'Search') {
              if (this.$route.query.tour === 'UpdateLevelClass') {
                this.$router.push('student?id=' + row.Student_ID + '&tour=UpdateLevelClass')
              } else {
                this.$router.push('student?id=' + row.Student_ID)
              }
            } else if (this.$route.query.mode === 'Course') {
              this.$router.push('student-edit-level?id=' + row.Student_ID)
            } else {
              alert('Error! Please try again later')
            }
          },
          label: 'Edit',
        },
      ],
      filterList: [
        {
          label: 'Academic Year',
          placeholder: 'Filter by academic year',
          optionList: [],
        },
        {
          label: 'Level',
          placeholder: 'Filter by level',
          optionList: [],
        },
        {
          label: 'Class',
          placeholder: 'Filter by class',
          optionList: [],
        },
      ],
      feedStat: [],
      staffData: null,
      studList: null,
      dateRange: [],
    }
  },
  mounted() {
    if (this.$route.params.Staff) {
      this.staffData = this.$route.params.Staff
      this.studList = this.$route.params.studList
      this.dateRange = this.$route.params.dateRange
      this.init()
    } else {
      this.handleBack()
    }
  },
  methods: {
    lang,
    async init() {},
    handleBack() {
      this.$router.push('/Dashboard')
    },
  },
}
</script>
